import { createReducer, on } from '@ngrx/store';

import {
  insertIdentification,
  insertIdentificationFailure,
  insertIdentificationSuccess,
  showIdentification,
} from './actions';
import { IdentificationState } from '../models/identification.state';

const initialState = {
  show: false,
};

export const identificationReducer = createReducer<IdentificationState>(
  initialState,
  on(showIdentification, () => ({
    show: true,
  })),
  on(insertIdentification, (state, { data, fileName, mediaType }) => ({
    ...state,
    insertIdentification: { data, fileName, mediaType },
  })),
  on(
    insertIdentificationSuccess,
    (state) =>
      ({
        ...state,
        insertIdentification: undefined,
        show: false,
      }) as IdentificationState,
  ),
  on(
    insertIdentificationFailure,
    (state) =>
      ({
        ...state,
        insertIdentification: undefined,
        show: false,
      }) as IdentificationState,
  ),
);
